// ============================================
// Path: /frontend/src/api/admin.api.js
// Purpose: Admin dashboard API endpoints
// ============================================

import apiClient from './client.js';

export const adminAPI = {
  // Get dashboard statistics
  getStats: async () => {
    console.log('[adminAPI] Fetching dashboard stats');
    try {
      const response = await apiClient.get('/admin/stats');
      console.log('[adminAPI] Stats fetched:', response.data);
      return response.data;
    } catch (error) {
      console.error('[adminAPI] Error fetching stats:', error);
      throw error;
    }
  },

  // Get user analytics
  getUserAnalytics: async () => {
    console.log('[adminAPI] Fetching user analytics');
    try {
      const response = await apiClient.get('/admin/analytics/users');
      console.log('[adminAPI] User analytics fetched');
      return response.data;
    } catch (error) {
      console.error('[adminAPI] Error fetching user analytics:', error);
      throw error;
    }
  },

  // Get listing analytics
  getListingAnalytics: async () => {
    console.log('[adminAPI] Fetching listing analytics');
    try {
      const response = await apiClient.get('/admin/analytics/listings');
      console.log('[adminAPI] Listing analytics fetched');
      return response.data;
    } catch (error) {
      console.error('[adminAPI] Error fetching listing analytics:', error);
      throw error;
    }
  },

  // Get system settings
  getSettings: async () => {
    console.log('[adminAPI] Fetching system settings');
    try {
      const response = await apiClient.get('/admin/settings');
      console.log('[adminAPI] Settings fetched');
      return response.data;
    } catch (error) {
      console.error('[adminAPI] Error fetching settings:', error);
      throw error;
    }
  },

  // Update system settings
  updateSettings: async (settings) => {
    console.log('[adminAPI] Updating system settings:', settings);
    try {
      const response = await apiClient.patch('/admin/settings', settings);
      console.log('[adminAPI] Settings updated successfully');
      return response.data;

    } catch (error) {
      console.error('[adminAPI] Error updating settings:', error);
      throw error;
    }
  },

  // Get all payment history (admin only)
  getPaymentHistory: async (page = 1, limit = 50, filters = {}) => {
    console.log('[adminAPI] Fetching payment history');
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...filters
      });
      const response = await apiClient.get(`/admin/payments/history?${params}`);
      console.log('[adminAPI] Payment history fetched');
      return response.data;
    } catch (error) {
      console.error('[adminAPI] Error fetching payment history:', error);
      throw error;
    }
  },
};